<template>
  <div class="header flex flex-ac">
    <h1 class="logo pointer" @click="tohome">
      <img src="@/assets/logo2.png" alt="" />
    </h1>
    <div class="tabs flex flex-ac">
      <!-- <div
        v-if="userInfo?.vip_status != 'inactive_affiliate' || false"
        @click="topath('/memberinfo')"
        :class="$route.path == '/memberinfo' && 'text-B4926E'"
      >
        {{ $t('sidebar.memberManagement') }}
      </div>
      <div
        @click="topath('/incomedetails')"
        :class="$route.path == '/incomedetails' && 'text-B4926E'"
      >
        {{ $t('sidebar.bonusManagement') }}
      </div>
      <div
        @click="topath('/purchasemeal')"
        :class="$route.path == '/purchasemeal' && 'text-B4926E'"
      >
        {{ $t('sidebar.purchasePackage') }}
      </div>
      <div
        @click="topath('/order')"
        :class="$route.path == '/order' && 'text-B4926E'"
      >
        {{ $t('sidebar.orderManagement') }}
      </div>
      <div
        @click="topath('/notify')"
        :class="$route.path == '/notify' && 'text-B4926E'"
      >
        {{ $t('sidebar.messageNotifications') }}
      </div>
      <div
        @click="topath('/points_RP?type=1')"
        :class="$route.path == '/points_RP' && 'text-B4926E'"
      >
        {{ $t('sidebar.pointsSystem') }}
      </div> -->
    </div>
    <div class="flex flex-ac user">
      <div
        class="iconfont icon-icon1 notice pointer"
        @click="topath('/notify')"
      >
        <div v-if="userInfo?.unread_num > 0" class="badge"></div>
      </div>
      <div class="flex flex-ac pos-relative">
        <div class="iconfont icon-icon2 icon2"></div>
        <div
          class="text-2c2c2c pointer"
          @click.stop="handleClickOutside($event, true)"
        >
          {{
            userInfo?.username ??
            userInfo?.email ??
            userInfo?.contact ??
            userInfo?.phone ??
            ' '
          }}
        </div>
        <div
          class="iconfont icon-down1 down1 pointer"
          @click.stop="handleClickOutside($event, true)"
        ></div>
        <el-collapse-transition>
          <div v-show="showinfotab" class="infotab" ref="popup">
            <div
              class="infotab-box xyac pointer text-nowrap"
              @click="topath('/accountInfo')"
            >
              {{ $t('sidebar.accountInfo') }}
            </div>
            <div
              class="infotab-box xyac pointer text-nowrap"
              @click="topath('/changepassword')"
            >
              {{ $t('sidebar.changePassword') }}
            </div>
            <div class="infotab-box xyac pointer" @click="loginout">
              {{ $t('sidebar.logout') }}
            </div>
          </div>
        </el-collapse-transition>
      </div>

      <el-dropdown @command="handleCommand">
        <div class="iconfont icon-icon3 pointer"></div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="en_US">English</el-dropdown-item>
          <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      showinfotab: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event, isenvet = false) {
      if (isenvet) {
        this.showinfotab = true
      } else {
        const popup = this.$refs.popup
        if (popup && !popup.contains(event.target)) {
          this.showinfotab = false
        }
      }
    },
    loginout() {
      this.$store.dispatch('FedLogOut').then(() => {
        this.$router.replace({
          path: '/login',
        })
      })
    },
    handleCommand(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('lang', locale)
      location.reload()
    },
    topath(path) {
      this.$router.push({ path: path })
      this.showinfotab = false
    },
    tohome() {
      this.$router.push({ path: '/' })
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  flex-shrink: 0;
  box-sizing: border-box;
  background: #ffffff;
  height: 3.75rem;
  border-bottom: 1px solid #f3f4f7;
}

.logo {
  margin-left: 2.25rem;
  margin-right: 6.63rem;

  img {
    width: 7.31rem;
  }
}

.badge {
  position: absolute;
  width: 0.3rem;
  height: 0.3rem;
  background: red;
  top: 0;
  right: 0;
  border-radius: 50%;
}

.tabs {
  flex-grow: 1;
  color: #2c2c2c;
  & > div {
    cursor: pointer;
    font-size: 0.88rem;
    line-height: 1.25rem;
    margin-right: 3rem;
  }
}

.notice {
  position: relative;
  margin-right: 1.88rem;
}

.user {
  height: 100%;
  margin-right: 2.31rem;
}

.icon2 {
  margin-right: 0.31rem;
}

.down1 {
  margin-right: 1.25rem;
}

.infotab {
  position: absolute;
  z-index: 99;
  top: 2rem;
  right: 0;
  // width: 6.94rem;
  // height: 5.63rem;
  background: #ffffff;
  box-shadow: 0rem 0.13rem 0.88rem 0rem rgba(0, 0, 0, 0.25);
  border-radius: 0.25rem;
  border: 0.06rem solid #f3f4f7;

  &-box {
    box-sizing: border-box;
    height: 2.69rem;
    width: 100%;
    padding: 0 0.94rem;
  }
}
</style>
